import React from "react";
import { rolesType } from "../config/rolesType";
import { Outlet, Navigate } from "react-router";
import { getStore } from "../utils/universalFunction";
import Restriction from "../Components/Login/Restriction";
import ChangePassword from "../Pages/Modules/Auth/UserProfile/changePassword";
import TwoFactorAuth from "../Pages/Modules/Auth/TwoFactorAuth";
import AppSelectionPage from "../Pages/AppSelectionPage";
import StudySelectionPage from "../Pages/StudySelectionPage";
import DirectStudyLogin from "../Pages/DirectStudyLogin";
const auth = getStore("token");
const role = JSON.parse(localStorage.getItem("role"));
const twoFA = JSON.parse(localStorage.getItem("twoFA"));
const loginType = JSON.parse(localStorage.getItem("loginType"));
const updatePassword = JSON.parse(localStorage.getItem("updatePassword"));
const { user, client } = rolesType;

const AllPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : updatePassword ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const SharedPermission = () => {
  if (auth) {
    return <Outlet />
  } else {
    return <Navigate to="/login" />;
  }
};

const UserPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : user === role ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const CTMSPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : role === "ctms" ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const RandomizePermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : role === "iwrs" ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const CDISCPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : role === "cdisc" ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const RBQMPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : role === "rbqm" ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const EDCPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : role === "edc" ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const ETMFPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : role === "etmf" ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const EPROPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : role === "ePro" ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const ICFPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : role === "icf" ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const LUPPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : loginType === "studies" ? (
        <StudySelectionPage />
      ) : loginType === "apps" ? (
        <AppSelectionPage />
      ) : loginType === "loginDirect" ? (
        <DirectStudyLogin />
      ) : role === "LUP" ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const ClientPermission = () => {
  if (auth) {
    return twoFA ?
      <TwoFactorAuth /> :
      (!updatePassword ? (
        <ChangePassword />
      ) : client === role ? (
        <Outlet />
      ) : (
        <Restriction />
      ));
  } else {
    return <Navigate to="/login" />;
  }
};

const LoginPermission = () => {
  if (!auth) {
    return <Outlet to="/login" />;
  } else {
    return <Navigate to="/" />;
  }
};

export const Permission = {
  LoginPermission,
  AllPermission,
  SharedPermission,
  UserPermission,
  ClientPermission,
  CTMSPermission,
  CDISCPermission,
  RBQMPermission,
  EDCPermission,
  ETMFPermission,
  EPROPermission,
  LUPPermission,
  ICFPermission,
  RandomizePermission,
};
